export const API_ENDPOINTS = {
    'GET_MENU': '/kis/NMqNxPm8tpGZ3Rwj/api/node/group_menu',
    'GET_BLOCK': '/kis/NMqNxPm8tpGZ3Rwj/api/node/fb_block_section',
    'CONTENT_TYPE': 'fl-deposit-leads',
    'MENU_TPL': 'header-right',
    'THANKS_TPL': 'thanks-page',
    'FORM_TPL': 'form-content',
    'FOOTER_TPL': 'footer-block',
};